import { GetterTree } from 'vuex';
import { State } from '@/manager/payment/store/state';
import { Bank } from '@/manager/payment/models/bank.model';


export interface Getters {
    getBankList: Bank[];
}

export const getters: GetterTree<State, any> = {
    getBankList: (state) => state.list,
    getBank(state: State) {
        return (id: string) => {
            return state.list.find(
                (bank: any) => {
                    return bank.id === id;
                },
            );
        };
    },
};
